import { stringify } from 'query-string';
import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'REMEDIAL_GET',
  GET_SUCCESS: 'REMEDIAL_GET_SUCCESS',
  GET_FAILURE: 'REMEDIAL_GET_FAILURE',
  INVALIDATE_ITEM: 'REMEDIAL_INVALIDATE_ITEM',
  GET_ALL: 'REMEDIAL_GET_ALL',
  GET_ALL_SUCCESS: 'REMEDIAL_GET_ALL_SUCCESS',
  GET_ALL_FAILURE: 'REMEDIAL_GET_ALL_FAILURE',
  POST: 'REMEDIAL_POST',
  POST_SUCCESS: 'REMEDIAL_POST_SUCCESS',
  POST_FAILURE: 'REMEDIAL_POST_FAILURE',
  PATCH: 'REMEDIAL_PATCH',
  PATCH_SUCCESS: 'REMEDIAL_PATCH_SUCCESS',
  PATCH_FAILURE: 'REMEDIAL_PATCH_FAILURE',
};

export const get = actions.get(remedialId => `${BASE_V2_URL}/remedials/?${remedialId}`, {
  PENDING: ACTIONS.GET,
  SUCCESS: ACTIONS.GET_SUCCESS,
  FAILURE: ACTIONS.GET_FAILURE,
});

export const getAll = actions.getAll(
  query => `${BASE_V2_URL}/remedials/?${stringify(query)}`,
  {
    PENDING: ACTIONS.GET_ALL,
    SUCCESS: ACTIONS.GET_ALL_SUCCESS,
    FAILURE: ACTIONS.GET_ALL_FAILURE,
  },
);

export const post = actions.post(() => `${BASE_V2_URL}/remedials/`, {
  PENDING: ACTIONS.POST,
  SUCCESS: ACTIONS.POST_SUCCESS,
  FAILURE: ACTIONS.POST_FAILURE,
});

export const patch = actions.patch(
  remedialId => `${BASE_V2_URL}/remedials/${remedialId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
